export enum Environment {
  dev = 'dev',
  test = 'test',
  prod = 'prod',
}
